export default "__VITE_ASSET__B9VeRGL3__"